/**
 * One of the usages of this enum is to call Backend routes in falcor, So be careful when modifying it.
 */
var SubscriptionServiceOfferEnum;
(function (SubscriptionServiceOfferEnum) {
    SubscriptionServiceOfferEnum["Chromatic"] = "Chromatic";
    SubscriptionServiceOfferEnum["Distribution"] = "Distribution";
    SubscriptionServiceOfferEnum["Mastering"] = "Mastering";
    SubscriptionServiceOfferEnum["Samples"] = "Samples";
    SubscriptionServiceOfferEnum["Sessions"] = "Sessions";
    SubscriptionServiceOfferEnum["Bundles"] = "Bundles";
})(SubscriptionServiceOfferEnum || (SubscriptionServiceOfferEnum = {}));

export { SubscriptionServiceOfferEnum };
